export default __webpack_public_path__ + "static/media/ground.7585d64f.png";